module.exports = require("././angular-translate-storage-cookie.js");


//////////////////
// WEBPACK FOOTER
// angular-translate-storage-cookie (bower component)
// module id = 383
// module chunks = 1